module.exports = __webpack_public_path__ + "img/thumb-fabrica.7dc9cf8b.jpg";